import NearbyComponentMap from 'src/components/user-mobile/map/nearby-attraction/NearbyComponentMap';
import TopFixedBarNearby from 'src/components/user-mobile/map/nearby-attraction/TopFixedBarNearby';

export default function NearbyMapHome() {
  return (
    <div>
      <TopFixedBarNearby text="삽교호 주변 관광지" />
      <NearbyComponentMap />
    </div>
  );
}
